import {
	IS_LOADING,
	SET_FILTERED_AND_SORTED_SITE_MONITORINGS,
	SET_CURRENT_SITE_MONITORING,
	SET_SITE_MONITORING_FILTERS,
	SET_SITE_MONITORINGS,
	SET_ALL_TAGS,
	READER_ROLE,
	MANAGER_ROLE,
	USER_ROLE,
	SET_SITE_MONITORING_SELECTED_TAB,
	DETAILS_TAB_INDEX,
} from "./siteMonitoringConstants";
import { throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import {
	adaptSiteMonitoringForMyOpen,
	adaptSiteMonitoringForDb,
	adaptUserAndRightsForOpenERP,
	adaptSiteMonitoringFromOpenERP,
} from "./siteMonitoringCast";
import { deleteLotInDb, getLots, synchronizeLots } from "./lotActions";
import {
	getNotes,
	countNotesAssignedToMe,
	getDefaultNotesFilters,
	setNotesFiltersAction,
	getDocumentsAttachment,
} from "./noteActions";
import { getPlans, synchronizePlans, deletePlanInDb, actualizeAllAnnotationsLabel, getPlansAttachment } from "./planActions";
import db from "../../db";
import { clone, downloadFile } from "../../utils";
import { ALL_SELECT_OPTION } from "../../constants";

export function siteMonitoringsIsLoading(value) {
	return {
		type: IS_LOADING,
		info: "site_monitorings",
		isLoading: value,
	};
}

export function setFilteredAndSortedSiteMonitoringsAction(siteMonitorings) {
	return {
		type: SET_FILTERED_AND_SORTED_SITE_MONITORINGS,
		siteMonitorings,
	};
}

export function setSiteMonitoringsAction(siteMonitorings) {
	return {
		type: SET_SITE_MONITORINGS,
		siteMonitorings,
	};
}

export function setAllTagsAction(allTags) {
	return {
		type: SET_ALL_TAGS,
		allTags,
	};
}

export function setCurrentSiteMonitoringAction(siteMonitoring) {
	return {
		type: SET_CURRENT_SITE_MONITORING,
		currentSiteMonitoring: siteMonitoring,
	};
}

export function setSiteMonitoringFiltersAction(filters) {
	return {
		type: SET_SITE_MONITORING_FILTERS,
		filters: filters,
	};
}

export function setSelectedTabAction(selectedTab) {
	return {
		type: SET_SITE_MONITORING_SELECTED_TAB,
		selectedTab,
	}
}

export function setFilteredAndSortedSiteMonitorings(
	siteMonitoringsFilters,
	siteMonitorings,
	userId
) {
	return (dispatch) => {
		dispatch(siteMonitoringsIsLoading(true));
		if (!siteMonitorings) {
			db.SiteMonitoring.toArray()
				.then(async (siteMonitorings) => {
					let transformedSiteMonitorings = [];

					await Promise.all(
						siteMonitorings.map(async (sm) => {
							sm.nbNotesAssignedToMe = await countNotesAssignedToMe(sm, userId);
							transformedSiteMonitorings.push(adaptSiteMonitoringForMyOpen(sm));
						})
					);

					dispatch(setSiteMonitoringsAction(transformedSiteMonitorings));
					dispatch(
						applyFiltersAndSortSiteMonitorings(
							siteMonitoringsFilters,
							transformedSiteMonitorings
						)
					);
					dispatch(siteMonitoringsIsLoading(false));
				})
				.catch((err) => {
					console.error(
						"Erreur : siteMonitoringsActions - setFilteredAndSortedSiteMonitorings",
						err
					);
					dispatch(
						throwErrorMessage({
							errorObject: err,
							title: "Erreur",
							message:
								"Erreur lors de la récupération des suivis de chantier !",
						})
					);
					dispatch(siteMonitoringsIsLoading(false));
				});
		} else {
			siteMonitorings.forEach(async (sm) => {
				sm.nbNotesAssignedToMe = await countNotesAssignedToMe(sm, userId);
			});

			dispatch(
				applyFiltersAndSortSiteMonitorings(
					siteMonitoringsFilters,
					siteMonitorings,
					userId
				)
			);
		}
	};
}

export function updateFilters(filters, allSiteMonitorings, userId) {
	return (dispatch) => {
		dispatch(setSiteMonitoringFiltersAction(filters));
		dispatch(
			applyFiltersAndSortSiteMonitorings(filters, allSiteMonitorings, userId)
		);
	};
}

export function submitSiteMonitoringInDb(siteMonitoring) {
	return new Promise((resolve, reject) => {
		return db
			.transaction("rw?", db.SiteMonitoring, () => {
				return db.SiteMonitoring.filter((currentSiteMonitoring) => {
					return (
						currentSiteMonitoring.id &&
						currentSiteMonitoring.id === siteMonitoring.id
					);
				})
					.toArray()
					.then((siteMonitorings) => {
						let siteMonitoringForDb = adaptSiteMonitoringForDb(siteMonitoring);

						if (siteMonitorings.length === 0) {
							db.SiteMonitoring.add(siteMonitoringForDb)
								.then((createdSiteMonitoring) => {
									return resolve(createdSiteMonitoring);
								})
								.catch((err) => {
									console.error(err);
									return reject(err);
								});
						} else {
							db.SiteMonitoring.update(
								siteMonitoringForDb.id,
								siteMonitoringForDb
							)
								.then((updatedSiteMonitoringByMobileId) => {
									return resolve(updatedSiteMonitoringByMobileId);
								})
								.catch((err) => {
									console.error(err);
									return resolve(
										db.SiteMonitoring.update(
											siteMonitoringForDb.id,
											siteMonitoringForDb
										)
									);
								});
						}
					})
					.catch((err) => {
						console.error(err);
						return reject(err);
					});
			})
			.catch((err) => {
				console.error(err);
				return reject(err);
			});
	});
}

export function getAllTags(user) {
	return (dispatch) => {
		dispatch(siteMonitoringsIsLoading(true));

		const headers = new Headers({ "Content-Type": "application/json" });
		fetchWithTimeout("/api/v1/siteMonitorings/get_all_tags", {
			method: "POST",
			headers: headers,
			body: JSON.stringify({
				userId: user.id,
			}),
		})
			.then((response) => {
				if (!response.ok) throw Error(response.statusText);

				return response;
			})
			.then((response) => response.json())
			.then((allTags) => {
				dispatch(setAllTagsAction(allTags));
				dispatch(siteMonitoringsIsLoading(false));
			});
	};
}

function applyFiltersAndSortSiteMonitorings(
	siteMonitoringsFilters,
	siteMonitorings
) {
	return (dispatch) => {
		let filteredSiteMonitorings = filter(
			siteMonitoringsFilters,
			siteMonitorings
		);
		dispatch(
			setFilteredAndSortedSiteMonitoringsAction(filteredSiteMonitorings)
		);
		dispatch(siteMonitoringsIsLoading(false));
	};
}

function filter(siteMonitoringsFilters, siteMonitorings) {
	let filteredSiteMonitorings = siteMonitorings
		.sort(sortBySiteNumber)
		.filter((siteMonitoring) => {
			return (
				filterByNumero(siteMonitoringsFilters, siteMonitoring) &&
				filterByCity(siteMonitoringsFilters, siteMonitoring) &&
				filterByCustomer(siteMonitoringsFilters, siteMonitoring) &&
				filterByOnlyWithRequiredAction(
					siteMonitoringsFilters,
					siteMonitoring
				) &&
				filterByState(siteMonitoringsFilters, siteMonitoring)
			);
		});

	return filteredSiteMonitorings;
}

function filterByNumero(filters, siteMonitoring) {
	return filters.siteNumber
		? siteMonitoring.code
			.toLowerCase()
			.includes(filters.siteNumber.toLowerCase())
		: true;
}

function filterByCity(filters, siteMonitoring) {
	if (!filters.city) return true;

	if (
		!siteMonitoring.delivery_partner_id ||
		!siteMonitoring.delivery_partner_id.city
	)
		return false;

	return siteMonitoring.delivery_partner_id.city
		.toLowerCase()
		.includes(filters.city.toLowerCase());
}

function filterByCustomer(filters, siteMonitoring) {
	if (!filters.customer) return true;

	if (
		!siteMonitoring.delivery_partner_id ||
		(!siteMonitoring.delivery_partner_id.customer_code &&
			!siteMonitoring.delivery_partner_id.name)
	)
		return false;

	return (
		siteMonitoring.delivery_partner_id.customer_code
			.toLowerCase()
			.includes(filters.customer.toLowerCase()) ||
		siteMonitoring.delivery_partner_id.name
			.toLowerCase()
			.includes(filters.customer.toLowerCase())
	);
}

function filterByOnlyWithRequiredAction(filters, siteMonitoring) {
	return filters.requireAction ? siteMonitoring.nbNotesAssignedToMe > 0 : true;
}

function filterByState(filters, siteMonitoring) {
	return filters.status && filters.status.length > 0
		? filters.status.some((status) => status === ALL_SELECT_OPTION) ||
		filters.status.some((status) => status === siteMonitoring.state)
		: true;
}

function sortBySiteNumber(noteA, noteB) {
	return noteA.code.localeCompare(noteB.code);
}

export function loadSiteMonitoring(siteMonitoring, user) {
	return (dispatch) => {
		let defaultNotesFilters = getDefaultNotesFilters();
		dispatch(setNotesFiltersAction(defaultNotesFilters));
		dispatch(setCurrentSiteMonitoringAction(siteMonitoring));
		dispatch(getNotes(siteMonitoring, defaultNotesFilters, user));
		dispatch(getLots(siteMonitoring));
		dispatch(getPlans(siteMonitoring));
		dispatch(setSelectedTab(DETAILS_TAB_INDEX));
	};
}

export function blocHasChanged(blocA, blocB) {
	if (blocA.deleted !== blocB.deleted)
		throw new Error("Le bloc a été supprimé");

	if (blocA !== blocB) throw new Error("Les blocs sont différents");

	return false;
}

export function removeSiteMonitoring(
	siteMonitoring,
	history,
	siteMonitoringsFilters,
	userId
) {
	return (dispatch) => {
		return deleteSiteMonitoringInDb(siteMonitoring).then(() => {
			if (siteMonitoringsFilters)
				dispatch(
					setFilteredAndSortedSiteMonitorings(
						siteMonitoringsFilters,
						null,
						userId
					)
				);

			history.push("/siteMonitorings");
		});
	};
}

export function synchronizeSiteMonitorings(user, history, onSynchronized, siteMonitoringListFilters, discreet) {
	return (dispatch) => {
		const headers = new Headers({ "Content-Type": "application/json" });

		if (!discreet)
			dispatch(siteMonitoringsIsLoading(true));

		fetchWithTimeout("/api/v1/siteMonitorings/get_site_monitorings", {
			method: "POST",
			headers: headers,
			timeout: 60000,
			body: JSON.stringify({
				userId: user.id,
			}),
		})
			.then((response) => {
				if (!response.ok) throw Error(response.statusText);

				return response;
			})
			.then((response) => response.json())
			.then((serverSiteMonitorings) => {
				db.SiteMonitoring.toArray()
					.then((dbSiteMonitorings) => {
						let transformedSiteMonitorings = clone(dbSiteMonitorings);
						let promises = [];

						let dbSiteMonitoringsAlwaysInOpenErp = [];

						serverSiteMonitorings.forEach((ssm) => {
							let transformedSiteMonitoring = ssm;
							transformedSiteMonitoring = adaptSiteMonitoringFromOpenERP(ssm);

							let dbSiteMonitoring = transformedSiteMonitorings.find(
								(dbi) => dbi.id === ssm.id
							);

							if (dbSiteMonitoring)
								dbSiteMonitoringsAlwaysInOpenErp.push(dbSiteMonitoring);

							promises.push(
								dispatch(
									synchronizeSiteMonitoring(
										dbSiteMonitoring,
										transformedSiteMonitoring,
										user
									)
								)
							);
						});

						dbSiteMonitorings.forEach((dbsm) => {
							if (
								!dbSiteMonitoringsAlwaysInOpenErp
									.map((sm) => sm.id)
									.includes(dbsm.id)
							)
								promises.push(
									dispatch(
										removeSiteMonitoring(
											dbsm,
											history,
											siteMonitoringListFilters,
											user.id
										)
									)
								);
						});

						Promise.all(promises).then(() => {
							if (!discreet)
								dispatch(siteMonitoringsIsLoading(true));

							//Récupération des pièces jointes que myOpen n'a pas encore téléchargé
							let attachmentsPromises = [
								dispatch(getPlansAttachment(user)),
								dispatch(getDocumentsAttachment(user)),
							];

							Promise.all(attachmentsPromises).then(() => {
								dispatch(actualizeAllAnnotationsLabel(user));

								if (onSynchronized && typeof onSynchronized === "function")
									onSynchronized();

								if (!discreet)
									dispatch(siteMonitoringsIsLoading(false));
							})
						}).catch(() => {
							if (!discreet)
								dispatch(siteMonitoringsIsLoading(false));
						});
					})
					.catch((err) => {
						console.error(
							"Erreur : siteMonitoringActions - synchronizeSiteMonitorings",
							err
						);

						if (!discreet) {
							dispatch(
								throwErrorMessage({
									errorObject: err,
									title: "Erreur",
									message: "Erreur lors de la récupération des chantiers !",
								})
							);

							dispatch(siteMonitoringsIsLoading(false));
						}
					});
			})
			.catch((err) => {
				console.error(
					"Erreur : siteMonitoringActions - synchronizeSiteMonitorings",
					err
				);

				if (!discreet) {
					dispatch(
						throwErrorMessage({
							errorObject: err,
							title: "Erreur",
							message: "Erreur lors de la récupération des chantiers !",
						})
					);

					dispatch(siteMonitoringsIsLoading(false));
				}
			});
	};
}

export function deleteSiteMonitoringInDb(siteMonitoring) {
	db.SiteMonitoringLot.filter((lot) => {
		return lot.affair_id === siteMonitoring.id;
	})
		.toArray()
		.then((dbLots) => {
			dbLots.forEach((dbl) => {
				deleteLotInDb(dbl);
			});
		});

	db.SiteMonitoringPlan.filter((plan) => {
		return plan.affair_id === siteMonitoring.id;
	})
		.toArray()
		.then((dbPlans) => {
			dbPlans.forEach((dbp) => {
				deletePlanInDb(dbp);
			});
		});

	return db.SiteMonitoring.delete(siteMonitoring.id);
}

export function synchronizeSiteMonitoring(
	dbSiteMonitoring,
	transformedSiteMonitoring,
	user
) {
	return (dispatch) => {
		if (dbSiteMonitoring)
			transformedSiteMonitoring.internalState = dbSiteMonitoring.internalState;

		dispatch(synchronizeLots(transformedSiteMonitoring, user));
		dispatch(synchronizePlans(transformedSiteMonitoring));
		return submitSiteMonitoringInDb(transformedSiteMonitoring);
	};
}

export function siteMonitoringIsDisabled(siteMonitoring, activeUser) {
	let userAndAuthorizations = siteMonitoring.site_supervision_authorized_user_ids.find(
		(u) => u.user_id ? u.user_id.id === activeUser.id : false
	);

	if (!userAndAuthorizations) {
		console.error(
			"Impossible que l'utilisateur courant ne soit pas dans la liste des utilisateurs autorisés pour cette affaire"
		);
		return false;
	}

	return userAndAuthorizations.rights === READER_ROLE;
}

export function userIsSiteMonitoringManager(user, siteMonitoring) {
	let userAndAuthorizations = siteMonitoring.site_supervision_authorized_user_ids.find(
		(u) => u.user_id ? u.user_id.id === user.id : false
	);

	if (!userAndAuthorizations) {
		console.error(
			"Impossible que l'utilisateur courant ne soit pas dans la liste des utilisateurs autorisés pour cette affaire"
		);
		return false;
	}

	return userAndAuthorizations.rights === MANAGER_ROLE;
}

export function formatRole(role) {
	switch (role) {
		case USER_ROLE:
			return "Utilisateur";
		case MANAGER_ROLE:
			return "Manager";
		case READER_ROLE:
			return "Lecture seule";
		default:
			return role;
	}
}

export function setUsersAndRights(siteMonitoring, userAndRights, user) {
	return (dispatch) => {
		const headers = new Headers({ "Content-Type": "application/json" });

		userAndRights = adaptUserAndRightsForOpenERP(userAndRights);

		const body = {
			userAndRights: userAndRights,
			userId: user.id,
		};

		dispatch(siteMonitoringsIsLoading(true));

		fetchWithTimeout("/api/v1/siteMonitoring/userAndRights/save", {
			method: "POST",
			headers: headers,
			body: JSON.stringify(body),
		})
			.then(function (response) {
				if (!response.ok) throw Error(response.statusText);

				return response;
			})
			.then((response) => response.json())
			.then((userAndRightsId) => {
				userAndRights = siteMonitoring.site_supervision_authorized_user_ids
					.filter((u) => u.user_id)
					.find((u) => u.user_id.id === userAndRights.user_id);

				if (!userAndRights.id)
					siteMonitoring.site_supervision_authorized_user_ids = addCreationUserAndRightsIfNeeded(
						siteMonitoring.site_supervision_authorized_user_ids,
						siteMonitoring.id
					);

				if (userAndRightsId && userAndRightsId === parseInt(userAndRightsId, 10))
					userAndRights.id = userAndRightsId;

				db.SiteMonitoring.update(
					siteMonitoring.id,
					adaptSiteMonitoringForDb(siteMonitoring)
				);
				dispatch(setCurrentSiteMonitoringAction(siteMonitoring));
				dispatch(siteMonitoringsIsLoading(false));
			})
			.catch((err) => {
				console.error(
					"Erreur : siteMonitoringActions - setUsersAndRights: " + err.message
				);
				dispatch(
					throwErrorMessage({
						title: "Erreur",
						message:
							"Une erreur s'est produite lors de la sauvegarde les droits utilisateur",
					})
				);

				dispatch(siteMonitoringsIsLoading(false));
			});
	};
}

export function deleteUserAndRights(siteMonitoring, userAndRights, user) {
	return (dispatch) => {
		const headers = new Headers({ "Content-Type": "application/json" });

		userAndRights = adaptUserAndRightsForOpenERP(userAndRights);

		const body = {
			userAndRights: userAndRights,
			userId: user.id,
		};

		dispatch(siteMonitoringsIsLoading(true));

		fetchWithTimeout("/api/v1/siteMonitoring/userAndRights/delete", {
			method: "POST",
			headers: headers,
			body: JSON.stringify(body),
		})
			.then(function (response) {
				if (!response.ok) throw Error(response.statusText);

				return response;
			})
			.then((response) => response.json())
			.then(() => {
				db.SiteMonitoring.update(
					siteMonitoring.id,
					adaptSiteMonitoringForDb(siteMonitoring)
				);
				dispatch(setCurrentSiteMonitoringAction(siteMonitoring));
				dispatch(siteMonitoringsIsLoading(false));
			})
			.catch((err) => {
				console.error("Erreur : lotActions - deleteLot: " + err.message);
				dispatch(
					throwErrorMessage({
						title: "Erreur",
						message:
							"Une erreur s'est produite lors de la suppression des droits pour cet utilisateur",
					})
				);

				dispatch(siteMonitoringsIsLoading(false));
			});
	};
}

export function addCreationUserAndRightsIfNeeded(usersAndRights, affair_id) {
	let indexOfCreationLine = usersAndRights.find(function (element) {
		return !element.user_id;
	});

	if (!indexOfCreationLine)
		usersAndRights.push(getDefaultUserAndRights(affair_id));

	return usersAndRights;
}

export function getDefaultUserAndRights(affair_id) {
	return {
		id: 0,
		user_id: null,
		affair_id: affair_id,
		rights: READER_ROLE,
	};
}

export function downloadReport(notes, siteMonitoring, user) {
	return (dispatch) => {
		if (notes.some((n) => !n.id)) {
			dispatch(
				throwErrorMessage({
					title: "Erreur",
					message:
						"Une erreur s'est produite lors du téléchargement du rapport. Les notes n'ont pas été synchronisées avec OpenERP",
				})
			);

			return;
		}

		let noteIds = notes.map((n) => n.id);

		dispatch(siteMonitoringsIsLoading(true));
		const headers = new Headers({ "Content-Type": "application/json" });
		fetchWithTimeout("/api/v1/siteMonitoring/download", {
			method: "POST",
			headers: headers,
			body: JSON.stringify({
				noteIds,
				affairId: siteMonitoring.id,
				userId: user.id,
			}),
		})
			.then((response) => {
				if (!response.ok) throw Error(response.statusText);

				return response;
			})
			.then((response) => response.json())
			.then((file) => {
				var dataURI = "data:application/pdf;base64," + file;
				downloadFile(dataURI, "Rapport");
				dispatch(siteMonitoringsIsLoading(false));
			})
			.catch((err) => {
				console.error(
					"Erreur : siteMonitoringActions - downloadReport: " + err.message
				);

				dispatch(
					throwErrorMessage({
						title: "Erreur",
						message:
							"Une erreur s'est produite lors du téléchargement du rapport",
					})
				);

				dispatch(siteMonitoringsIsLoading(false));
			});
	};
}

export async function getSiteMonitoring(id) {
	return await db.SiteMonitoring.filter(sm => sm.id === id).toArray()
		.then((siteMonitorings) => {

			if (!siteMonitorings || siteMonitorings.length > 1 || siteMonitorings.length <= 0) {
				console.error("Plusieurs chantiers avec le même identifiant ont été trouvés");
				return null;
			}

			return adaptSiteMonitoringForMyOpen(siteMonitorings[0]);
		})
}

export function setSelectedTab(selectedTab) {
	return (dispatch) => {
		dispatch(setSelectedTabAction(selectedTab));
	}
}
